module.exports = __webpack_public_path__ + "media/images/twitter-415baac0143ec196ef60bc762204dba5.svg";